'use client';

import { latestNewsGridSection } from '@stereoagency/sanity-schema';
import { useContext } from 'react';
import useSWR from 'swr';
import { newsQuery } from './newsQuery';
import LatestNewsGridSection from './LatestNewsGridSection.client';
import { SanityDraftClientContext } from '@/components/context';

type Props = Omit<
  typeof latestNewsGridSection.schema.latestNewsGridSection,
  '_type'
> & {};

export default function DraftModeLatestNewsGridSection({
  title,
  action
}: Props) {
  const { client } = useContext(SanityDraftClientContext);
  const { data } = useSWR('latest-news', () =>
    client?.fetch<(typeof newsQuery)[1]>(newsQuery[0])
  );

  return (
    <LatestNewsGridSection
      title={title}
      action={action}
      articles={data ?? []}
    />
  );
}
